// src/FireBase.js
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
const firebaseConfig = {
  apiKey: "AIzaSyCy44kFBBwNVfmks9CoycNMDmzjSlzHkuQ",
  authDomain: "kabili.firebaseapp.com",
  projectId: "kabili",
  storageBucket: "kabili.firebasestorage.app",
  messagingSenderId: "169914960678",
  appId: "1:169914960678:web:5c8fced9fe1140cf07cfe7",
  measurementId: "G-DK0KN24RK8"
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);
// Initialize Firebase Auth and Firestore

const auth = getAuth(app);

const storage = getStorage(app);


export { app, auth, db ,storage};